export default "__VITE_ASSET__BoqatDhb__"